<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="category == 'isCreate' && $permission('111')"
        v-on="on"
        v-bind="attrs"
        class="info"
        small
      >
        <v-icon small left>mdi-plus</v-icon>
        {{ $t("createCategory") }}
      </v-btn>
      <v-btn
        v-else-if="category != 'isCreate' && $permission('113')"
        v-on="on"
        v-bind="attrs"
        small
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card :height="deletingCategory ? '500' : ''">
      <v-toolbar flat tile class="flex-grow-0">
        <v-toolbar-title class="title">
          <span v-if="deletingCategory">{{ $t("deleteCategory") }}</span>
          <span v-else-if="category == 'isCreate'">{{
            $t("createCategory")
          }}</span>
          <span v-else>{{ $t("editCategory") }}</span>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="form" v-model="validForm">
        <v-card-text v-show="!deletingCategory" class="my-4">
          <div class="pt-4 px-6">
            <v-text-field
              v-model="categoryName"
              :label="$t('categoryNameLabel')"
              outlined
              dense
              hide-details="auto"
              :rules="requiredRules"
              :counter="45"
              maxlength="45"
              :disabled="category.standard == 1"
            ></v-text-field>
          </div>

          <div class="pa-4 px-6">
            <v-textarea
              v-model="categoryDescription"
              :label="$t('description')"
              outlined
              dense
              hide-details="auto"
              :counter="500"
              maxlength="500"
              :disabled="category.standard == 1"
            ></v-textarea>
          </div>

          <div class="pa-4 px-6">
            <v-text-field
              v-model="categoryWeightOrder"
              :label="$t('weight')"
              outlined
              dense
              hide-details="auto"
              :rules="requiredRules"
              onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
              :counter="3"
              maxlength="3"
              clearable
            >
              <template v-slot:append-outer>
                <div class="tooltip">
                  <v-icon class="tooltipIcon">
                    mdi-information-outline
                  </v-icon>
                  <div class="tooltipText">
                    <span class="title">{{ $t("categoryWeight") }}</span>
                    <p class="mt-4 body-1">
                      {{ $t("categoryWeightTxt") }}
                    </p>
                  </div>
                </div>
              </template>
            </v-text-field>
          </div>
          <div class="pa-4 px-6">
            <v-select
              v-model="casinoLive"
              :items="casinoLiveSelect"
              :label="$t('casinoType')"
              outlined
              dense
              hide-details="auto"
              :menu-props="{ bottom: true, offsetY: true }"
              :disabled="category.standard == 1"
            ></v-select>
          </div>

          <!-- Tipo de layout do grid, será implementado mais à frente -->
          <!-- <div class="pa-4 px-6">
            <v-select
              v-model="categoryLayoutType"
              :items="layoutTypeSelect"
              label="Tipo de Layout"
              solo-inverted
              dense
              hide-details="auto"
            ></v-select>
          </div> -->

          <div class="pa-4 px-6 mb-5">
            <v-select
              v-model="categoryStatus"
              :items="categoryStatusSelect"
              label="Status"
              outlined
              dense
              :menu-props="{ bottom: true, offsetY: true }"
              hide-details="auto"
            ></v-select>
          </div>

          <!-- div do upload de ícone, será implementada mais à frente -->
          <!-- <div class="px-6">
            <div class="d-flex align-center justify-space-between mb-2">
              <p style="font-size: 0.9em; margin-bottom: 0;">
                Faça upload do icon da categoria
              </p>
              <v-btn
              class="info"
              small
              @click="uploadIcon()"
              >
                <v-icon>mdi-tray-arrow-up</v-icon>
              </v-btn>
            </div>
            <div>
              <p style="font-size: 10px; color: rgba(255, 255, 255, 0.6);">
                O arquivo deve ter até 80x80px de dimensão <br>
                Os seguintes tipos de arquivo são aceitos: .pnh, .jpg, .pdf
              </p>
            </div>
          </div> -->
        </v-card-text>

        <!-- excluir categoria Alert -->
        <div v-show="deletingCategory">
          <v-card-text class="d-flex justify-center mt-8">
            <v-alert
              border="left"
              max-width="600"
              colored-border
              type="info"
              color="#B50000"
              elevation="2"
            >
              <span style="font-size: 12px; font-weight: 400;">
                {{ $t("deletingCategoryAlert") }}
              </span>
            </v-alert>
          </v-card-text>
          <v-card-text class="mb-10">
            <div class="d-flex justify-center">
              {{ $t("areYouSureToDelete") }}
            </div>
          </v-card-text>

          <v-card-actions class="px-10 pb-8">
            <v-row no-gutters>
              <v-col
                :cols="$vuetify.breakpoint.xs ? '12' : ''"
                :class="
                  $vuetify.breakpoint.xs
                    ? 'd-flex flex-column-reverse'
                    : 'd-flex justify-center'
                "
              >
                <v-btn
                  :class="
                    $vuetify.breakpoint.xs
                      ? 'white black--text mb-6 ml-0'
                      : 'white black--text px-9'
                  "
                  outlined
                  :block="$vuetify.breakpoint.xs"
                  small
                  :disabled="loading"
                  @click.prevent="deletingCategory = false"
                >
                  {{ $t("cancel") }}
                </v-btn>

                <v-btn
                  :class="$vuetify.breakpoint.xs ? 'ml-0 mb-6' : 'px-9 ml-4'"
                  :block="$vuetify.breakpoint.xs"
                  small
                  color="#B50000"
                  type="submit"
                  @click.prevent="deleteCategory"
                  :loading="loading"
                  :disabled="loading || !validForm"
                >
                  {{ $t("yes") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </div>
        <!-- excluir categoria Alert END -->

        <v-divider v-if="!deletingCategory"></v-divider>
        <v-card-actions v-if="!deletingCategory" class="d-flex flex-wrap pa-4">
          <v-row
            no-gutters
            :class="$vuetify.breakpoint.xs ? 'd-flex flex-column' : ''"
          >
            <v-col
              xs="12"
              :class="$vuetify.breakpoint.xs ? 'd-flex justify-end mt-6' : ''"
              :order="$vuetify.breakpoint.xs ? 'last' : ''"
            >
              <v-btn
                v-if="category != 'isCreate' && $permission('114')"
                class=""
                color="#B50000"
                @click.prevent="deletingCategory = true"
                :disabled="category.standard == 1"
              >
                {{ $t("delete") }}
              </v-btn>
            </v-col>
            <v-col
              xs="12"
              class="d-flex justify-end"
              :order="$vuetify.breakpoint.xs ? 'first' : ''"
            >
              <v-spacer></v-spacer>
              <v-btn
                class="mr-4 white black--text"
                :disabled="loading"
                @click.prevent="dialog = false"
              >
                {{ $t("toCancel") }}
              </v-btn>

              <v-btn
                class="info"
                type="submit"
                @click.prevent="
                  category == 'isCreate' ? createCategory() : editCategory()
                "
                :loading="loading"
                :disabled="loading || !validForm"
              >
                {{ $t("toSave") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate";

export default {
  name: "update-category",
  props: ["category"],
  data: () => ({
    dialog: false,
    loading: false,
    validForm: false,
    deletingCategory: false,
    editCategoryName: false,

    // models
    categoryName: "",
    categoryDescription: "",
    categoryWeightOrder: "",
    casinoLive: "",
    categoryLayoutType: "",
    categoryStatus: "",

    // rules
    requiredRules: [validate.required],
  }),

  computed: {
    casinoLiveSelect() {
      return [
        {
          text: this.$t("casino"),
          value: 0,
        },
        {
          text: this.$t("liveCasino"),
          value: 1,
        },
      ];
    },

    categoryStatusSelect() {
      return [
        {
          text: this.$t("ativa"),
          value: 1,
        },
        {
          text: this.$t("inativa"),
          value: 0,
        },
      ];
    },
  },

  watch: {
    dialog(val) {
      val && this.handleCategory();
    },
  },

  methods: {
    handleCategory() {
      this.categoryId = this.category.id;
      this.categoryName = this.category.name;
      this.categoryDescription = this.category.description;
      this.categoryWeightOrder = this.category.weight_order;

      this.casinoLive =
        this.category.live == 1
          ? this.casinoLiveSelect[1].value
          : this.casinoLiveSelect[0].value;

      if (this.category == "isCreate") {
        this.categoryStatus = this.categoryStatusSelect[0].value;
      } else {
        this.categoryStatus =
          this.category.status == 1
            ? this.categoryStatusSelect[0].value
            : this.categoryStatusSelect[1].value;
      }
    },

    createCategory() {
      this.loading = true;
      const body = {
        name: this.categoryName,
        description: this.categoryDescription ? this.categoryDescription : "",
        status: this.categoryStatus,
        // layout_type não será implementado agora, passar 1 por enquanto
        // layout_type: this.categoryLayoutType,
        layout_type: 1,
        weight_order: this.categoryWeightOrder,
        live: this.casinoLive,
      };

      this.$axios
        .post(
          "colab/cassino/GamesAgregation/addCategorie",
          this.$formdata(body)
        )
        .then((response) => {
          this.$store.commit("setFeedbackSnack", {
            msg: response.data.dados,
            color: "success",
          });
          this.$emit("refreshList");
          this.dialog = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },

    editCategory() {
      this.loading = true;
      const body = {
        id: this.categoryId,
        name: this.categoryName,
        description: this.categoryDescription,
        status: this.categoryStatus,
        // layout_type não será implementado agora, passar 1 por enquanto
        // layout_type: this.categoryLayoutType,
        layout_type: 1,
        weight_order: this.categoryWeightOrder,
        live: this.casinoLive,
      };

      this.$axios
        .post(
          "colab/cassino/GamesAgregation/editCategorie",
          this.$formdata(body)
        )
        .then((response) => {
          this.$store.commit("setFeedbackSnack", {
            msg: response.data.dados,
            color: "success",
          });
          this.$emit("refreshList");
          this.dialog = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },

    // uploadIcon() {
    //   console.log('Upload Icon...')
    // },

    deleteCategory() {
      this.loading = true;
      const body = {
        id: this.categoryId,
      };
      this.$axios
        .post(
          "colab/cassino/GamesAgregation/deleteCategorie",
          this.$formdata(body)
        )
        .then((response) => {
          this.$store.commit("setFeedbackSnack", {
            msg: response.data.dados,
            color: "success",
          });
          this.deletingCategory = false;
          this.dialog = false;
          this.$emit("refreshList");
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },

    closeDialog() {
      this.deletingCategory = false;
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.v-tooltip__content {
  max-width: 320px;
}
.tooltipIcon {
  color: rgb(33, 150, 243);
}

.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip .tooltipText {
  visibility: hidden;
  width: 320px;
  margin: auto;
  max-width: 280px;
  background-color: rgb(87, 87, 87);
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 12px 16px;
  bottom: 36px;
  right: -10%;
  hyphens: auto;
  word-break: normal;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltipText {
  visibility: visible;
}
</style>
